import { assetUrl } from '@utils/assetUrl'

export const GAMES = {
  DEFENDER: {
    gameName: 'Defender',
    layout: 'STANDARD',
    modes: ['NORMAL', 'MINI'],
    themes: ['DEFAULT', 'MOG', 'PEPE'],
    defaultMode: 'NORMAL',
    defaultTheme: 'DEFAULT',
    background: {
      type: 'SOLID_COLOR',
      source: {
        DEFAULT: null,
      },
    },
    // MINI layout, per-game bits only (icon / tagline / accent). The rest of the
    // mini look comes from the shared `--standard-mini-*` theme tokens; the
    // accent is injected onto the mini root as `--standard-mini-accent-color`.
    mini: {
      icon: assetUrl('images/mini-icons/DEFENDER.webp'),
      title: 'Mini Defender',
      tagline: 'Cash Out Before the Crash.',
      accentColor: '#29B6F6',
    },
  },
  HOWZZAT: {
    gameName: 'Howzzat',
    layout: 'STANDARD',
    modes: ['NORMAL', 'MINI'],
    themes: ['DEFAULT', 'MOG', 'PEPE'],
    defaultMode: 'NORMAL',
    defaultTheme: 'DEFAULT',
    background: {
      type: 'SOLID_COLOR',
      source: {
        DEFAULT: null,
      },
    },
    mini: {
      icon: assetUrl('images/mini-icons/HOWZZAT.webp'),
      title: 'Mini Howzzat',
      tagline: 'Cash Out Before the Wicket.',
      accentColor: '#2E7CF6',
    },
  },
  CRASH: {
    gameName: 'Crash',
    layout: 'STANDARD',
    modes: ['NORMAL', 'MINI'],
    themes: ['DEFAULT', 'MOG', 'PEPE'],
    defaultMode: 'NORMAL',
    defaultTheme: 'DEFAULT',
    background: {
      type: 'IMAGE',
      source: {
        DEFAULT: assetUrl('images/background-images/CRASH_BG_IMAGE.webp'),
      },
    },
  },
  ROCKET_BOOM: {
    gameName: 'Rokcet Boom',
    layout: 'STANDARD',
    modes: ['NORMAL', 'MINI'],
    themes: ['DEFAULT', 'MOG', 'PEPE'],
    defaultMode: 'NORMAL',
    defaultTheme: 'DEFAULT',
  },
  COMET: {
    gameName: 'Comet',
    layout: 'UNIQUE',
    modes: ['MINI'],
    themes: ['DEFAULT', 'MOG', 'PEPE'],
    defaultMode: 'MINI',
    defaultTheme: 'DEFAULT',
  },
}
